import type { BibleBook, BibleBookId } from "@packages/sdk";
import type { StyleXArray } from "@packages/ui";
import { useScrollToOnLoad } from "@packages/ui";

import type { BibleNavBookItemProps } from "./BibleNavBookItem";
import { BibleNavBookItem } from "./BibleNavBookItem";
import { BibleNavSectionHeader } from "./BibleNavSectionHeader";

type BibleNavBookSectionProps = {
  headerStyleXArray: StyleXArray;
  books: BibleBook[];
  itemStyleXArray: StyleXArray;
  itemStyle: BibleNavBookItemProps["itemStyle"];
  title: string;
  titlePosition?: number;
  navBook: BibleBookId;
  onItemClick: (id: BibleBookId, e: Event | MouseEvent) => void;
};

export const BibleNavBookSection = ({
  headerStyleXArray,
  title,
  titlePosition,
  books,
  itemStyleXArray,
  itemStyle,
  navBook,
  onItemClick,
}: BibleNavBookSectionProps) => {
  const selectedBookRef = useScrollToOnLoad<HTMLDivElement>({
    block: "center",
  });

  return books?.length ? (
    <>
      <BibleNavSectionHeader
        styleXArray={headerStyleXArray}
        position={titlePosition}
      >
        {title}
      </BibleNavSectionHeader>
      {books.map((b, idx) => (
        <BibleNavBookItem
          key={`${b.id}_item`}
          b={b}
          idx={idx}
          onItemClick={onItemClick.bind(null, b.id)}
          itemStyle={itemStyle}
          selected={b.id === navBook}
          styleXArray={itemStyleXArray}
          ref={b.id === navBook ? selectedBookRef : null}
        />
      ))}
    </>
  ) : null;
};
